__turbopack_context__.v({
  "fieldset": "MobileFilters-module-scss-module__2OVRXa__fieldset",
  "filters_close_icon": "MobileFilters-module-scss-module__2OVRXa__filters_close_icon",
  "label": "MobileFilters-module-scss-module__2OVRXa__label",
  "legend": "MobileFilters-module-scss-module__2OVRXa__legend",
  "linear_shadow": "MobileFilters-module-scss-module__2OVRXa__linear_shadow",
  "mobile_controls": "MobileFilters-module-scss-module__2OVRXa__mobile_controls",
  "mobile_filters": "MobileFilters-module-scss-module__2OVRXa__mobile_filters",
  "mobile_filters_button": "MobileFilters-module-scss-module__2OVRXa__mobile_filters_button",
  "mobile_filters_title": "MobileFilters-module-scss-module__2OVRXa__mobile_filters_title",
  "mobile_sort_by_select": "MobileFilters-module-scss-module__2OVRXa__mobile_sort_by_select",
  "radio": "MobileFilters-module-scss-module__2OVRXa__radio",
  "radio_label": "MobileFilters-module-scss-module__2OVRXa__radio_label",
});
